/**
 * Global authority directive
 * Used for fine-grained control of component permissions
 * @Example v-auth="RoleEnum.TEST"
 */
import type { Directive, DirectiveBinding } from 'vue';
import { RoleEnum } from '@mts/enums/roleEnum';
import { usePermission } from '@mts/hooks/web/usePermission';

const { hasPermission } = usePermission();

const authDirective: Directive = {
  mounted: (el: Element, binding: DirectiveBinding<string | string[] | RoleEnum[]>) => {
    const value = binding.value;
    if (!value) return;
    if (!hasPermission(value)) {
      el.parentNode?.removeChild(el);
    }
  },
};

export default authDirective;
